import { createWebClient, IUnknownRecord, IWebClient } from "@cd2/skeem-client"
import { IMutation, Models } from "../types/schema"

declare global {
  interface Window {
    skeem: IWebClient
  }
}

export const skeemWebClient = createWebClient({ url: "/skeem" })
;(window as any).skeem = skeemWebClient

export function useSkeem() {
  return window.skeem
}

export function useTypedSkeemMutate() {
  const skeem = useSkeem()
  return function <T = IUnknownRecord>(
    query: {
      [key in keyof Models]: { [key2 in key]: unknown } & IMutation<key>
    }[keyof Models],
  ) {
    return skeem.mutate<T>(query)
  }
}

export function andSkeemFilter(...filters: any[]) {
  const x = filters.filter(Boolean)
  if (x.length === 1) {
    return x[0]
  } else {
    return { and: x }
  }
}

/**
 * Filter for records whose `company` attribute sits inside the given base company's organisation,
 * i.e. the base company itself or any of its sub companies. Works for any model with a `company`
 * association (users, flowResults, employees, etc.). Use when surfacing records across
 * sub-companies of a head company.
 */
export function inBaseCompanyOrgFilter(baseCompanyId: string) {
  return {
    or: [
      { matches: { company: baseCompanyId } },
      { matches: { company: { matches: { headCompany: baseCompanyId } } } },
    ],
  }
}
